<template>
  <div class="container-md d-flex justify-content-center payment_methods">
    <template v-if="loading">
      <spinner variant="success" />
    </template>

    <div v-else>
      <div  class="card border-primary">
        <div class="card-header text-white bg-primary mb-3">
          <label class="col-6">{{ client.name }}</label>
          <template v-if="client.sessionsStripe">
            <label class="col-6 text-end">
              <template v-if="client.sessionsStripe.is_payment && client.sessionsStripe.is_subscription">
                Next payment date
              </template>
              <template v-if="client.sessionsStripe.is_payment && client.sessionsStripe.is_subscription == 0">
                Subscription valid till
              </template>
              {{ client.sessionsStripe.period_end }}
            </label>
          </template>
        </div>

        <div class="card-body">
          <TableField
              :data="client.objects"
              :columns="columns"
              :loading="loading"
              :columnChooser="false"
              :enablePagination="false"
              mobileDevices
          >
            <template #cell-vehicleNumbers="{ value }">
              <template v-for="(vehicleNumber, index) in value">
                {{ vehicleNumber }}<span v-if="index !== value.length - 1">, </span>
              </template>
            </template>
            <template #cell-oneObjectPrice="{ value }">{{ value }} €</template>
            <template #cell-totalRowPrice="{ value }">{{ parseFloat(value).toFixed(2) }} €</template>
          </TableField>
        </div>
      </div>

      <h4 class="d-flex justify-content-center pt-5">
        <b>
          <label>Total to pay:</label>
          {{ parseFloat(client.totalAmount).toFixed(2) }} €
        </b>
      </h4>
      <div class="d-flex justify-content-center" v-if="client.clientId">
        <button v-if="client.sessionsStripe == null" type="button" class="btn btn-primary px-5 py-3" @click="subscribe()">
          {{ $t('stripeForm.btn-subscribe') }}
        </button>

        <button
            v-else-if="client.sessionsStripe && client.sessionsStripe.is_payment == 1 && client.sessionsStripe.is_subscription == 1"
            type="button"
            class="btn btn-primary px-5 py-3"
            @click="sendMessageUnsubscribe()"
        >
          {{ $t('stripeForm.btn-unsubscribe') }}
        </button>
      </div>
    </div>
  </div>

  <MessageBox ref="sendMsgUnsubscribeBox" @confirm="sendMessageUnsubscribe($event, 1)" />
</template>

<style>
 .payment_methods .bh-pagination {
    display: none;
  }
</style>

<script src="./StripeForm.js"></script>
